import { render } from "./talleres.vue?vue&type=template&id=27d1a6ed"
import script from "./talleres.vue?vue&type=script&lang=js"
export * from "./talleres.vue?vue&type=script&lang=js"
script.render = render

export default script